import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SelfServiceDetailsModel } from '../../models/SelfServiceDetails';
import { SelfServiceService } from '../../services/self-service.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '../../services/snackbar.service';
import { TranslocoService } from '@jsverse/transloco';
import { Person, PERSONS } from '../../models/persons';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ConditionsComponent } from '../../components/conditions/conditions.component';
import moment from 'moment';

@Component({
  selector: 'app-self-service',
  templateUrl: './self-service.component.html',
  styleUrls: ['./self-service.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelfServiceComponent implements OnInit {
  componentDestroyed$: Subject<boolean> = new Subject();

  selfServiceCheckForm: UntypedFormGroup;
  selfServiceForm: UntypedFormGroup;
  isLoading = false;
  selfServiceData: SelfServiceDetailsModel;

  persons: Person[] = PERSONS;

  arriveAtParking60Min: string;
  arriveAtParking75Min: string;
  arriveAtParking90Min: string;
  arriveAtParking105Min: string;
  arriveAtParking120Min: string;
  arriveAtParking135Min: string;
  arriveAtParking150Min: string;
  arriveAtParking165Min: string;
  arriveAtParking180Min: string;
  arriveAtParking195Min: string;
  arriveAtParking210Min: string;
  arriveAtParking225Min: string;
  arriveAtParking240Min: string;
  arriveAtParking255Min: string;
  arriveAtParking270Min: string;

  numberRegEx = /\-?\d*\.?\d{1,2}/;

  constructor(private selfServiceService: SelfServiceService, private fb: UntypedFormBuilder, private snackBar: SnackbarService, public translate: TranslocoService, public dialog: MatDialog) {
    this.selfServiceCheckForm = this.fb.group({
      ordernumber: ['', Validators.required],
      lastname: ['', Validators.required],
    });

    this.selfServiceForm = this.fb.group({
      carRegNumber: ['', [Validators.minLength(6), Validators.required]],
      cellular: ['', [Validators.minLength(10), Validators.pattern(this.numberRegEx), Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      passengers: ['', Validators.required],
      parkingFrom: ['', Validators.required],
      consent: ['', Validators.requiredTrue],
      contact: [false],
      comment: [''],
    });
  }

  ngOnInit(): void {

  }

  loadDetails() {
    this.isLoading = true;
    this.selfServiceService.GetDetailsByOrderNumberLastname(this.selfServiceCheckForm.controls['ordernumber'].value, this.selfServiceCheckForm.controls['lastname'].value)
      .then((model) => {
        if (!model) {
          this.isLoading = false;
          this.snackBar.openSnackBar(this.translate.translate('FLYGETS.SELFSERVICE.VALIDATION_NOK'), 'OK');
          this.selfServiceCheckForm.reset();
          return;
        }
        this.selfServiceForm.patchValue({
          carRegNumber: model.carRegNumber,
          cellular: model.cellular,
          email: model.email,
          passengers: model.passengers,
          parkingFrom: model.parkingShuttleFrom,
          comment: model.comment
        });
        this.selfServiceData = model;
        this.selfServiceData.orderNumber = this.selfServiceCheckForm.controls['ordernumber'].value;
        this.selfServiceData.lastname = this.selfServiceCheckForm.controls['lastname'].value;
        this.populateParkingStartTime(model.parkingFrom);
        this.isLoading = false;
      }).catch((error) => {
        console.error(error);
        this.isLoading = false;
        this.snackBar.openSnackBar(this.translate.translate('FLYGETS.SELFSERVICE.VALIDATION_NOK'), 'OK');
        this.selfServiceCheckForm.reset();
      });
  }

  saveDetails() {
    this.isLoading = true;
    this.selfServiceService.SaveDetailsByOrderNumberLastname(
      this.selfServiceData.orderNumber,
      this.selfServiceData.lastname,
      this.selfServiceForm.controls["carRegNumber"].value,
      this.selfServiceForm.controls["cellular"].value,
      this.selfServiceForm.controls["email"].value,
      this.selfServiceForm.controls["passengers"].value,
      this.selfServiceForm.controls["parkingFrom"].value,
      this.selfServiceForm.controls["contact"].value,
      this.selfServiceForm.controls["comment"].value,
    )
      .then((model) => {
        this.selfServiceData = model;
        this.isLoading = false;
        this.snackBar.openSnackBar(this.translate.translate('FLYGETS.SELFSERVICE.SAVE_OK'), 'OK');
      }).catch((error) => {
        console.error(error);
        this.isLoading = false;
        this.snackBar.openSnackBar(this.translate.translate('FLYGETS.SELFSERVICE.SAVE_NOK'), 'OK');
      });


    this.isLoading = false;
  }

  resetSelfServiceCheckForm() {
    this.selfServiceCheckForm.reset();
  }

  resetSelfServiceForm() {
    this.selfServiceForm.patchValue({
      carRegNumber: this.selfServiceData.carRegNumber,
      cellular: this.selfServiceData.cellular,
      email: this.selfServiceData.email,
      passengers: this.selfServiceData.passengers,
      parkingFrom: null,
      contact: false,
      comment: this.selfServiceData.comment,
    });
  }

  onParkingStartChange(event: MatSelectChange) {
    console.log(moment(event.value).utc().toDate());
    // this.newItemEvent.emit(this.getTravelTime(this.selectedFlight, moment(event.value).utc().toDate()));
  }

  public openConsent() {
    const dialogRef = this.dialog.open(ConditionsComponent, {
      disableClose: true,
      data: true
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(data => {
        //this.bookingForm.controls['consent'] = data;
      });
  }

  private populateParkingStartTime(startTime: Date) {
    this.arriveAtParking60Min = moment(startTime)
      .subtract(60, 'm')
      .format();
    this.arriveAtParking75Min = moment(startTime)
      .subtract(75, 'm')
      .format();
    this.arriveAtParking90Min = moment(startTime)
      .subtract(90, 'm')
      .format();
    this.arriveAtParking105Min = moment(startTime)
      .subtract(105, 'm')
      .format();
    this.arriveAtParking120Min = moment(startTime)
      .subtract(120, 'm')
      .format();
    this.arriveAtParking135Min = moment(startTime)
      .subtract(135, 'm')
      .format();
    this.arriveAtParking150Min = moment(startTime)
      .subtract(150, 'm')
      .format();
    this.arriveAtParking165Min = moment(startTime)
      .subtract(165, 'm')
      .format();
    this.arriveAtParking180Min = moment(startTime)
      .subtract(180, 'm')
      .format();
    this.arriveAtParking195Min = moment(startTime)
      .subtract(195, 'm')
      .format();
    this.arriveAtParking210Min = moment(startTime)
      .subtract(210, 'm')
      .format();
    this.arriveAtParking225Min = moment(startTime)
      .subtract(225, 'm')
      .format();
    this.arriveAtParking240Min = moment(startTime)
      .subtract(240, 'm')
      .format();
    this.arriveAtParking255Min = moment(startTime)
      .subtract(255, 'm')
      .format();
    this.arriveAtParking270Min = moment(startTime)
      .subtract(270, 'm')
      .format();
  }

  compareParkingFrom(i1, i2) {
    return i1 && i2 && moment(i1).format() === moment(i2).format();
  }
}
